import { render, staticRenderFns } from "./ListTruck.vue?vue&type=template&id=ff19f494&"
import script from "./ListTruck.vue?vue&type=script&lang=js&"
export * from "./ListTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports